import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';

const SectionSpacial = ({ id, data, children }) => {
  const backgroundMb = convertDatasets(data?.dataSet ? data?.dataSet : data, 'background-mobile', true);
  const backgroundDt = convertDatasets(data?.dataSet ? data?.dataSet : data, 'background-desktop', true);
  return (
    <SectionWrapper id={id} backgroundMb={backgroundMb} backgroundDt={backgroundDt}>
      {children}
    </SectionWrapper>
  );
};

export default SectionSpacial;

const SectionWrapper = styled.div`
  background-image: url(${props => props.backgroundDt});
  background-color: #0600E7;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 30px;
  @media (max-width: 690px) {
    margin-top: 0;
    background-image: url(${props => props.backgroundMb});
  }

  .spacial-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 20px;
    grid-template-areas: 'spacial-grid-list spacial-grid-list spacial-grid-list spacial-grid-list';
    padding: 10px 15px;
    .spacial-date {
      text-align: center;
      font-size: 26px;
      color: #fff;
      font-weight: 300;
      margin: 15px 0 0;
      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
    .spacial-grid-list {
      display: grid;
      grid-area: spacial-grid-list;

      .block-wrapper {
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        flex-direction: column;
      }
      .row {
        display: grid;
        grid-template-columns: 3fr 1fr 1fr;
        grid-template-areas: 'spacial-score --item-1 --item-2 --item-3';
        .spacial-score {
          grid-area: spacial-score;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
        }
        @media (max-width: 1024px) {
          display: grid;
          grid-template-columns: 2fr 1fr;
          grid-template-areas:
            'spacial-score --item-1'
            'spacial-score --item-2';
          grid-gap: 15px;
          padding-bottom: 40px;

          .spacial-score {
            flex-direction: column;
            padding: 0px 10px;
          }
        }
        @media (max-width: 768px) {
          grid-template-columns: 1fr 1fr;
          grid-template-areas:
            'spacial-score spacial-score'
            ' --item-1 --item-2';
          grid-gap: 10px 0;
          .block-wrapper {
            padding: 10px;
          }
          .spacial-score {
            flex-direction: column;
            padding: 0px;
          }
        }
        .heading-spacial {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          max-width: 100%;
          grid-area: heading-spacial;
          &:nth-of-type(1) {
            margin-right: 30px;
            @media (max-width: 690px) {
              margin-right: 0;
            }
          }
        }
        .spacial-card {
          width: 100%;
          /* height: 100%; */
          margin: auto;
          background-color: #fff;
          padding: 10px;
          @media (min-width: 769px) and (max-width: 1024px) {
            border-radius: 8px;
          }
          &.--item-1 {
            grid-area: --item-1;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }

          &.--item-2 {
            grid-area: --item-2;
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
          &.--item-3 {
            grid-area: --item-3;
          }
        }
      }
    }
  }
  .spacial-logo {
    background-color: #fff;
    width: max-content;
    padding: 4px;
    border-radius: 100%;
    position: relative;
    overflow: hidden;
    grid-area: spacial-logo;
    filter: drop-shadow(3px 8px 5px #000000c3);
    margin: auto;

    max-width: 100%;
    img {
      width: 150px;
    }

    @media (max-width: 768px) {
      img {
        width: 100px;
      }
    }
    /* @media (max-width: 425px) {
      width: unset;
    } */
  }
  .spacial-link {
    width: 100%;
    text-align: end;
    margin: auto;
    position: absolute;
    bottom: 10px;
    @media (max-width: 690px) {
      margin-top: 10px;
    }
    a {
      color: #fff;
      position: relative;
      &:hover {
        svg {
          right: -10px;
        }
      }
      p {
        margin-right: 25px;

        display: inline-block;
      }
      svg {
        position: absolute;
        top: 52%;
        transform: translate(0, -50%);
        right: 0;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .block-wrapper {
    margin: auto;
    .card-v {
      margin: 0;
    }
  }
`;
